;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockAccordion from './BlockAccordion';

const query = /* GraphQL */ `
    ${assetFragment}
    ${ctaFragment}
    ${linkFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockAccordion(preview: $preview, id: $id) {
            __typename
            anchorId
            title
            eyebrow
            headline
            bodyCopy
            cta {
                ... on Cta {
                    ...CTA
                }
            }
            accordionItemsCollection(limit: 30) {
                items {
                    headline
                    bodyCopy {
                        json
                    }
                }
            }
            groupsCollection(limit: 10) {
                items {
                    title
                    headline
                    itemsCollection(limit: 10) {
                        items {
                            headline
                            bodyCopy {
                                json
                            }
                        }
                    }
                }
            }
            download {
                ...Asset
            }
            theme
            flushTop
            flushBottom
            backgroundColor
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockAccordion },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });

    return blockAccordion;
}

const BlockAccordionServer = async ({ id }) => {
    const block = await fetchBlock(id);

    return (
        <BlockAccordion
            {...block}
            accordionItems={block.accordionItemsCollection.items}
            groups={block.groupsCollection.items}
        />
    );
};

export default BlockAccordionServer;
